module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-input-number', _vm._g(_vm._b({
    class: _vm.align_class,
    style: ({
      width: _vm.w + 'px'
    }),
    attrs: {
      "min": _vm.$attrs.min || 0,
      "max": _vm.$attrs.max || 999999999.99,
      "size": _vm.$attrs.size || 'small',
      "controls": _vm.$attrs.controls || false
    }
  }, 'el-input-number', _vm.$attrs, false), _vm.$listeners))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18c71c10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SdInputNumber.vue
// module id = 713
// module chunks = 20